<!-- Header actions -->
<div class="content-center">
  <router-outlet name="overlay"></router-outlet>
  <app-reports-table-header
    [id]="id"
    [title]="title"
    [params]="params"
    [currentFilters]="filters"
    [currentColumnOptions]="columnOptions"
    (exportExcel)="exportExcel()"
    (exportCsv)="exportCsv()"
  ></app-reports-table-header>

  <!-- Totals -->
  <div class="totals">
    <div class="total-card" *ngFor="let t of totals">
      <div class="total-label">{{ t.label }}</div>
      <div
        class="total-value"
        [class.wrap-value]="t.value?.length > 8"
      >{{ t.value }}</div>
    </div>
  </div>

  <wm-filter-builder
    #filterCtrl
    *ngIf="params"
    [id]="id"
    [filterTypes]="filterTypes"
    [params]="params"
    [showSimpleSearch]="false"
    [savedFilters]="true"
    [columnOptions]="columnOptions"
    [staffFilterBuilder]="true"
    (columnsChange)="onColumnsChanged($event)"
    (exportColumnsChange)="onExportColumnsChange($event)"
    (filtersChange)="onFiltersChanged($event)"
  ></wm-filter-builder>

  <!-- Table -->
  <div class="contractor-summary-table">
    <wm-common-table
      tableType="Staff"
      [columns]="columns"
      [data]="rows"
      [showRowsPerPage]="true"
      [showTotalRecords]="true"
      [totalRecords]="page.totalElements"
      [pageSizeStorageKey]="'report-contractor-summary-janus'"
      (exportColumnsChange)="onExportColumnsChange($event)"
      (sortChanged)="onSortChanged($event)"
      [serverSidePagination]="true"
      [totalPages]="page.totalPages"
      [currentPage]="page.pageNumber"
      [pageSize]="page.size"
      [isLoading]="loading"
      [loaderType]="'Circular'"
      [errorMessage]="errorMessage"
      (retry)="onRetry()"
      (pageChange)="onPageChange($event)"
      (rowsPerPageChange)="onRowsPerPageChange($event)"
    ></wm-common-table>
  </div>

  <div
    class="overlay-backdrop"
    [class.show]="router.url.includes('scheduled-export')"
  >
    <div class="overlay-panel" (click)="$event.stopPropagation()">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
